'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterSetIsFiltered = exports.filterSetFilterValue = exports.filterSetFilters = undefined;

var _deep = require('helpers/deep');

var filterSetFilters = exports.filterSetFilters = function filterSetFilters(state, filterSet) {
  return (0, _deep.deepExtract)('filterSets.' + filterSet + '.filters', state, false);
};
var filterSetFilterValue = exports.filterSetFilterValue = function filterSetFilterValue(state, filterSet, filter) {
  return (0, _deep.deepExtract)('filterSets.' + filterSet + '.filters.' + filter + '.value', state, undefined);
};
var filterSetIsFiltered = exports.filterSetIsFiltered = function filterSetIsFiltered(state, filterSet) {
  return (0, _deep.deepExtract)('filterSets.' + filterSet + '.filtered', state, false);
};